import { asSeenOnLogos } from "@/mocks/ppcare";

export default function AsSeenOn() {
  return (
    <section className="border-y border-background-200/70 bg-background-100 py-10 md:py-14">
      <div className="container">
        <p className="mb-8 text-center font-label text-sm font-medium uppercase tracking-[0.25em] text-foreground-500">
          As Seen On
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-16">
          {asSeenOnLogos.map((logo) => (
            <img
              key={logo.name}
              src={logo.image}
              alt={logo.name}
              className="h-7 w-auto object-contain opacity-80 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0 md:h-9"
            />
          ))}
        </div>
      </div>
    </section>
  );
}